import { trans } from '@codebuild/cookie-jar/libs/translation/trans';
import React from 'react';
import { LoveStyleContent } from '../compatibility-infos/extras/modal-content/love-style-content';
import { EditModal } from '../shared/edit.modal';
import { DisplayBox } from './libs/display-box';

export class LoveStyleAnalysis extends DisplayBox {
    public title = trans('account.data.love.style.questionnaire');
    public buttonTitle = trans('account.data.view.data');
    public image = '/assets/images/profile/love-style.png';
    public modal$: EditModal | null;
    public questionnaire = 'love-style';
    public isQuestionnaireFilled = !!this.props.user.meta[`${this.questionnaire}Questionnaire`];

    public renderDescription(questionnaire: any) {
        if (!questionnaire) {
            return null;
        }

        const userAnalysisData = {
            gender: this.props.user.meta?.gender,
            data: this.props.user.meta?.[`${this.questionnaire}Questionnaire`] || {}
        };

        return <LoveStyleContent user={this.props.user} userAnalysisData={userAnalysisData}/>;
    }

    public renderImage() {
        return <img
            className={'h-px-162 width-auto'}
            src={this.image}
            alt={this.alt || trans('account.data.alt.icon.text')}
        />;
    }

    public renderModal(): null | JSX.Element {
        return <EditModal
            className={'max-width-848'}
            content={this.renderDescription(this.props.user.meta[`${this.questionnaire}Questionnaire`])}
            ref={ref => this.modal$ = ref}
        />;
    }

    public handleButtonClick(): void {
        this.modal$?.openModal();
    }
}
